import { Controller } from "stimulus"

export default class extends Controller {
  toggleConfirmationDialog() {
    document.getElementById(`offer-confirmation`).classList.toggle('c-modal--open');
  }
}